<template>
  <div class="card">
    <form class="form-horizontal">
      <div class="card-header">
        <h4 class="card-title">
          
        </h4>
      </div>
      <div class="card-content">
        

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Monthly Budget?</label>
            <div class="col-sm-6">
              <input type="number"
                     name="monthly"
                     data-vv-as="Monthly Budget"
                     v-validate="modelValidations.monthly"
                     v-model="model.monthly"
                     class="form-control">
              <small class="text-danger" v-show="monthly.invalid">
                {{ getError('monthly') }}
              </small>
            </div>
            <div class="col-sm-4">
             
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Weekly Budget?</label>
            <div class="col-sm-6">
              <input type="number"
                     name="weekly"
                     data-vv-as="Weekly Budget"
                     v-validate="modelValidations.weekly"
                     v-model="model.weekly"
                     class="form-control">
              <small class="text-danger" v-show="weekly.invalid">
                {{ getError('weekly') }}
              </small>
            </div>
            <div class="col-sm-4">
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Daily Budget?</label>
            <div class="col-sm-6">
              <input type="number"
                     name="daily"
                     data-vv-as="Daily Budget"
                     v-validate="modelValidations.daily"
                     v-model="model.daily"
                     class="form-control">
              <small class="text-danger" v-show="daily.invalid">
                {{ getError('daily') }}
              </small>
            </div>
            <div class="col-sm-4">
             
            </div>
          </div>
        </fieldset>

        
      </div>
      <div class="card-footer">
        <p-button type="info" @click.prevent="validate" class="info" round>{{ saveBudgetSettingButtonText }}</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    
    computed: {
      ...mapFields(['monthly', 'weekly', 'daily'])
    },
    data () {
      return {
        model: {
          monthly: '',
          weekly: '',
          daily: ''
        },
        modelValidations: {
          monthly: {
            required: true
          },
          weekly: {
            required: true
          },
          daily: {
            required: true
          },
        },
        saveBudgetSettingButtonText: 'Save Budget'
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.saveBudgetSettings (this.model)
        })
      },
      saveBudgetSettings (model) {
      
        this.saveBudgetSettingButtonText = 'Saving Budget ...'
        this.$http.post('/settings/budget', {
          monthly: model.monthly,
          weekly: model.weekly,
          daily: model.daily
        })
        .then(response=>{
          if(response.data.created_at){
           
            this.saveBudgetSettingButtonText = 'Budget Saved.'
          }
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
      },

      getUsersBudget () {
        this.$http.get ('/settings/budget')
        .then(response=>{
          var budgetSetting = response.data


          this.model.monthly = budgetSetting[0]['monthly']
          this.model.weekly = budgetSetting[0]['weekly']
          this.model.daily = budgetSetting[0]['daily']
        
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
      }
    },

    mounted () {
      this.getUsersBudget ()
    },

    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>

